import React, { useEffect, useRef } from 'react';
import { toast } from 'react-toastify';
import { useSendDocumentsJobContext } from '../../context';
import { ToastContent } from '../../components/react-toastify';

export default function SendDocumentsJob() {
  const { scheduled, error } = useSendDocumentsJobContext();
  const toastId = useRef(null);

  useEffect(() => {
    if (scheduled && !toastId.current) {
      toastId.current = toast(
        <ToastContent
          title="Emails Scheduled"
          titleProps={{ className: 'text-success' }}
          icon={['fas', 'check-circle']}
          message="Your emails have been successfully scheduled and will begin sending shortly."
        />,
        {
          autoClose: 8000,
          hideProgressBar: true,
          pauseOnHover: true
        }
      );
    }

    if (!scheduled) {
      toastId.current = null;
    }
  }, [scheduled]);

  useEffect(() => {
    if (error) {
      toast(
        <ToastContent
          title="Error Scheduling Emails"
          titleProps={{ className: 'text-danger' }}
          icon={['fas', 'times-circle']}
          message={error.message || 'An error occurred while scheduling your emails.'}
        />,
        {
          autoClose: 10000,
          hideProgressBar: true
        }
      );
    }
  }, [error]);

  return <></>;
}
